import styled from 'styled-components';

export default styled.div`
  position: ${props => props.isSingle ?  'fixed' : 'absolute'};
  top: ${props => props.isSingle ? '2rem' : props.hourOffset && props.hourOffsetHeight ? 'calc('+props.hourOffset +' * ('+ props.hourOffsetHeight+'))' : '0'};
  width: 99%;
  left: ${props => props.rowNumber && props.rowNumber > 1 && !props.isSingle ? 'auto' : '0'};
  height: ${props => props.isSingle ? 'auto' : props.howLong && props.hourOffsetHeight ? 'calc('+props.howLong +' * ( '+ props.hourOffsetHeight+' / 30))' : props.hourOffsetHeight};
  padding: ${props => props.padding ? 'calc('+props.padding +' / 2)' : '1rem'};
  padding-top: 0;
  min-height: 3.5rem;
  
  &:hover {
    z-index: 100;
  }
    
  ${props => props.isUnder || props.isSingle ? `
    > div {
      box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);
    }
  ` : ''};
  ${props => props.isSingle ? `
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    width: auto;
    height: 100%;
    bottom: 0;
    &:hover {
      z-index: 1000;
      filter: brightness(100%);
    }
    > div {
      min-height: 50vh;
    }
` : ''};
`;
